import { getAllAreas } from '../datas/law'
import * as tool from '../datas/tool'

export default {
  namespaced: true,
  state: {
    area: {
      data: {},
      tree: [],
      loaded: false
    }
  },
  actions: {
    getAllArea ({ state, commit }, data = {}) {
      if (!data.force && state.area.loaded) {
        return new Promise((resolve) => {
          resolve(true)
        })
      }
      return getAllAreas().then(res => {
        if (!res.response.success) return false
        commit('updateAreaData', res.data || [])
        return true
      })
    }
  },
  mutations: {
    updateAreaData (state, areaList) {
      const data = {}
      areaList.forEach(area => { data[area.id] = area })
      state.area.tree = tool.listToTree(areaList)
      state.area.data = data
    }
  },
  getters: {
    areaData (state) {
      return state.area.data
    },
    areaTree (state) {
      return state.area.tree
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/common.js